import {MetricsService} from '../../../services/metrics.service';
import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {SectionBase} from '../../../components/section/section-base';
import {OfferSectionInterface} from '../../../../core/services/api/sections-api/offer-section.interface';
import {isNullOrUndefined} from 'util';
import {OfferSectionStateService} from '../../../../core/services/impl/section-services/offers/offer-section-state.service';
import {Offer} from '../../../../core/models/offer/offer.model';
import {MatDialog} from '@angular/material';
import {FieldType} from '../../../models/field-type';
import {SelectContentText} from '../../../components/fields/multiselect/material-multiselect.component';
import {FormFactoryService} from '../../../services/form-factory.service';
import {FormGroup} from '@angular/forms';
import {ConfigurationService} from '../../../../core/services/impl/configuration/configuration.service';
import {Subject} from 'rxjs/Rx';
import {MetricsDataModel} from '../../../components/models/metrics/metrics-data.model';
import {TranslateService} from '@ngx-translate/core';
import {OfferMetricDataModel} from '../../../components/models/metrics/offer-metric-data.model';
import {OfferService} from '../../../../core/services/impl/offer.service';
import {CustomMetricsName} from '../../../components/models/metrics/custom-metrics-name.enum';
import {MetricsType} from '../../../components/models/metrics/metrics-type.enum';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {FiltersService} from '../../../services/filters.service';
import {MobileFiltersDialogComponent} from './mobile-filters-dialog/mobile-filters-dialog.component';
import {isMobile, isMPay, isNext, isSkycash} from '../../../../core/utils/utils';
import {FiltersApplicationMode} from './offers-filters/offers-filter/offers-filter.model';
import {UrlParamsService} from '../../../../core/services/impl/url-params.service';
import {Ga4CustomEventsHelper} from '../../../../core/utils/ga4-custom-events-helper';
import {GA4EventKey} from '../../../../core/consts/ga4-event-key.enum';
import {SortOrder} from '../../../enums/sort-order.enum';
import {OffersPresentationMode} from '../../../../core/services/impl/offers-presentation.service';
import {TestingPresetsService} from '../../../services/debugging/testing-presets.service';
import {TestingPresetKey} from '../../../../core/enums/debugging/testing-preset-key.enum';
import {
  OffersComparisonDialogComponent
} from '../../../components/dialogs/offers-comparison-dialog/offers-comparison-dialog.component';
import {OffersPresentationComponent} from './offers-presentation/offers-presentation.component';

@Component({
  selector: 'app-offer-section',
  templateUrl: './offer-section.component.html',
  styleUrls: ['./offer-section.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class OfferSectionComponent extends SectionBase implements OnInit, OfferSectionInterface, OnDestroy {

  readonly PRICE_SORT_ASC = 'priceSortAsc';
  readonly PRICE_SORT_DESC = 'priceSortDesc';
  readonly translationsContainer = 'OFFER_SECTION';

  // @ViewChild('filterComponent') filterComponent: OffersFilterComponent;
  selectedOffers: Offer[] = [];
  maxOffersToCheck: number;
  sortFormConfig;
  sortBean = { sort: this.PRICE_SORT_ASC };
  sortFormGroup: FormGroup = new FormGroup({});

  sortFormFactoryService: FormFactoryService;
  // metrics
  comparisonMetric: MetricsDataModel;
  selectMetric: MetricsDataModel;

  buttonIcon = 'keyboard_arrow_left';

  tiles: OfferSectionTile[];
  isNext: boolean = isNext();

  private _offers: Offer[] = [];

  get sortOffersVisible(): boolean {
    return !((isMPay() || isSkycash()) && this.urlParamsService.isMobileOrigin);
  }

  get offers(): Offer[] {
    return this.sortOffers();
  }

  get offersNumber(): number {
    return this.offers ? this.offers.length : 0;
  }

  get atLeastOneOfferExists(): boolean {
    return this.offers && this.offers.length > 0;
  }

  get pzuBannerVisible(): boolean {
    return this.configuration.uiConfig.pzuBannerVisible && this.atLeastOneOfferExists;
  }

  get comparisonMetricValue(): OfferMetricDataModel {
    let ids = [];
    this.selectedOffers.forEach(offer => ids.push(offer.id));
    return {
      offersIds: ids,
      calculationId: this.offerService.calculationId,
      processId: this.offerService.processId
    };
  }

  get filtersExpanded(): boolean {
    return this.filtersService.filtersExpanded;
  }

  get isMobile(): boolean {
    return isMobile();
  }

  selectMetricValue(offer): OfferMetricDataModel {
    return {
      offerId: offer.id,
      calculationId: this.offerService.calculationId,
      processId: this.offerService.processId
    };
  }

  constructor(private state: OfferSectionStateService,
              private dialog: MatDialog,
              private ts: TranslateService,
              public filtersService: FiltersService,
              private configuration: ConfigurationService,
              private metricsService: MetricsService,
              private urlParamsService: UrlParamsService,
              private offerService: OfferService) {
    super();
    this.state.offerSection = this;
    this.sortBean.sort = this.PRICE_SORT_ASC;
  }

  get selectedOffer(): Offer {
    return this.state.selectedOffer;
  }

  get valid(): boolean {
    return this.selectedOffer && !isNullOrUndefined(this.selectedOffer.id);
  }

  get checkOfferAvailable(): boolean {
    return this.selectedOffers.length < this.maxOffersToCheck;
  }

  get filtersEnabled() {
    return this.configuration.uiConfig.filtersEnabled && this.configuration.uiConfig.filtersEnabled;
  }

  get noOffersForFilters(): boolean {
    if (TestingPresetsService.isPresetActive(TestingPresetKey.REJECT_ALL_OFFERS)) {
      return true;
    }
    return this.offers.length === 0 && this.filtersService.filtersApplied;
  }

  get showFilters(): boolean {
    return !isMobile() && this.filtersService.filtersVisible;
  }

  ngOnInit() {
    this.setMaxOffersCountToCheck();
    this.createConfig();
    this.buildForm();
    this.buildSortForm();
    this.initControlsChanges();
    this.filtersService.initFilters();
    this.state.offersUpdate$.subscribe(() => this.updateTiles());
  }

  public ngOnDestroy(): void {
    this.state.offers = [];
  }

  createConfig() {
    this.formConfig = {
      formKey: 'OFFER_SECTION',
      fieldsConfig: []
    };

    this.sortFormConfig = {
      formKey: 'SORT_OFFER_COMPONENT',
      fieldsConfig: [
        {
          fieldKey: 'sort',
          type: FieldType.Select,
          caption: '',
          options: {
            item: 'key',
            label: { label: 'label' },
            items: [
              {
                key: this.PRICE_SORT_ASC,
                label: 'FILTER_OFFER_COMPONENT.SORT_COMPONENT.priceSortAsc',
                value: this.PRICE_SORT_ASC
              },
              {
                key: this.PRICE_SORT_DESC,
                label: 'FILTER_OFFER_COMPONENT.SORT_COMPONENT.priceSortDesc',
                value: this.PRICE_SORT_DESC
              },
            ]
          },
          select: {
            contentTextType: SelectContentText.CAPTION_TEXT,
            dropdownPosition: 'bottom',
            submitButton: false,
            searchable: true,
            clearOnClose: false,
            multiple: false
          },
          analyticsConfig: {
            eventsToSkip: [
                GA4EventKey.FIELD_CLICK,
            ]
          }
        }
      ]
    };

  }

  changeOffer(offer: Offer) {
  }

  setMaxOffersCountToCheck() {
    const clientWidth = document.body.clientWidth;
    if (clientWidth < 750) {
      this.maxOffersToCheck = 2
    } else {
      this.maxOffersToCheck = 4;
    }
  }

  checkOffer(offer: Offer) {
    this.selectedOffers.push(offer);
  }

  uncheckOffer(offer: Offer) {
    this.selectedOffers.splice(this.selectedOffers.indexOf(offer), 1);
  }

  offerChecked(offer: Offer): boolean {
    return !isNullOrUndefined(this.selectedOffers.find(item => item.id === offer.id))
  }

  compareOffers() {
    const selectOfferEvent = new Subject<Offer>();
    selectOfferEvent.subscribe(offer => this.selectOffer(offer));
    this.openMetric();
    const dialogComponent: any = this.isNext ? OffersComparisonDialogComponent : OffersPresentationComponent;
    this.dialog.open(dialogComponent,
        dialogComponent.getConfigBuilder().buildConfiguration({
        offers: this.state.sortOffersByPolicyAmount(this.selectedOffers, SortOrder.ASCENDING),
        mode: OffersPresentationMode.OFFERS_COMPARISON,
        selectOfferEvent
      })).afterClosed().subscribe(offer => {
      if (offer) {
        this.selectOffer(offer);
      }
      this.closeMetric();
    });
  }

  selectOffer(offer: Offer) {
    if (isNotNullOrUndefined(offer)) {
      this.state.changeOffer(offer);
    }
    this.sendSelectMetric(offer);
  }

  initBean() {
  }

  initControlsChanges(): void {
    this.sortFormGroup.controls['sort'].valueChanges.subscribe(value => {
      this.sortBean.sort = value;
      this.updateTiles();
      // this.filters.saveSortParamToLocal(value);
    });
  }

  changeFiltersVisibility(event: MouseEvent) {
    event.cancelBubble = true;
    this.filtersService.toggleFiltersVisibility();
    this.buttonIcon = this.filtersExpanded ? 'keyboard_arrow_left' : 'keyboard_arrow_right';
  }

  offersFiltersHeaderClick(): void {
    if (!this.filtersExpanded) {
      this.filtersService.toggleFiltersVisibility();
      this.buttonIcon = this.filtersExpanded ? 'keyboard_arrow_left' : 'keyboard_arrow_right';
    }
  }

  openMobileFilters(): void {
    const mobileFiltersDialog = this.dialog.open(MobileFiltersDialogComponent, {
      panelClass: 'mobile-filters-panel',
      closeOnNavigation: false,
      autoFocus: false,
      data: {}
    });
    mobileFiltersDialog.afterOpened().subscribe(() => this.filtersService.changeMode(FiltersApplicationMode.ON_CONFIRMATION));
    mobileFiltersDialog.afterClosed().subscribe(() => this.filtersService.changeMode(FiltersApplicationMode.AUTOMATIC));
  }

  shouldShowBanner(offerId: string): boolean {
    const offerPosition = this.tiles
        .filter(tile => tile.type === 'OFFER')
        .findIndex(tile => tile.item.id === offerId) + 1;

    return this.offerService.shouldShowOffersListBanner(offerPosition);
  }

  onSortSelectClick() {
    Ga4CustomEventsHelper.sortOffersSelectClickEvent.emit();
  }

  private updateTiles(): void {
    let tiles = [];
    const offers = this.sortOffers();
    const offerTiles = <OfferSectionTile[]>offers.map(offer => ({ type: 'OFFER', item: offer }));

    if (this.offerService.READONLY_OFFERS_ENABLED) {
      if (offers.length >= this.offerService.minOffersAmountForMixedInReadonlyBoxes) {
        tiles.push(...offerTiles);
        const registrationNumberBoxIndex = this.offerService.personalDataLogos.length ? 6 : 3;
        tiles.splice(3, 0, {
          type: 'READONLY_BOX',
          item: {type: 'PERSONAL_DATA', logos: this.offerService.personalDataLogos}
        });
        tiles.splice(registrationNumberBoxIndex, 0, {
          type: 'READONLY_BOX',
          item: {type: 'REGISTRATION_NUMBER', logos: this.offerService.registrationNumberLogos}
        });
      } else {
        tiles.push(
            {type: 'READONLY_BOX', item: {type: 'PERSONAL_DATA', logos: this.offerService.personalDataLogos}},
            {
              type: 'READONLY_BOX',
              item: {type: 'REGISTRATION_NUMBER', logos: this.offerService.registrationNumberLogos}
            },
            ...offerTiles
        );
      }
    } else {
      tiles.push(...offerTiles);
    }

    this.tiles = tiles;
  }

  private sortOffers(): Offer[] {
    switch (this.sortBean.sort) {
      case this.PRICE_SORT_ASC:
        return this.state.offers.sort((a: Offer, b: Offer) => Offer.getOfferPrice(a) - Offer.getOfferPrice(b));
      case this.PRICE_SORT_DESC:
        return this.state.offers.sort((a: Offer, b: Offer) => Offer.getOfferPrice(b) - Offer.getOfferPrice(a));
      default:
        return this.state.offers;
    }
  }

  private buildSortForm(): void {
    this.sortFormFactoryService = new FormFactoryService(this.sortFormConfig, this.sortBean);
    this.sortFormFactoryService.buildFormGroup(this.sortFormGroup);
  }

  private sendSelectMetric(offer): void {
    this.selectMetric = new MetricsDataModel(CustomMetricsName.SELECT_OFFER, MetricsType.BUTTON);
    this.selectMetric.change(JSON.stringify(this.selectMetricValue(offer)));
    this.metricsService.send(this.selectMetric);
  }

  private openMetric(): void {
    this.comparisonMetric = new MetricsDataModel(CustomMetricsName.OFFERS_COMPARISON, MetricsType.COMPONENT);
    this.comparisonMetric.open();
    this.comparisonMetric.value = JSON.stringify(this.comparisonMetricValue);
  }

  private closeMetric(): void {
    this.comparisonMetric.close();
    this.metricsService.send(this.comparisonMetric);
  }
}

export interface ReadonlyBox {
  type: 'PERSONAL_DATA' | 'REGISTRATION_NUMBER';
  logos: string[];
}

export interface OfferSectionTile {
  type: 'OFFER' | 'READONLY_BOX';
  item: any;
}
